<template>
    <div class="signUP-admin">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-xl-8 col-lg-7 col-md-7 col-sm-8">
                    <div class="signUp-admin-right signIn-admin-right p-md-40 p-10">
                        <div class="row justify-content-center">
                            <div class="col-xl-7 col-lg-8 col-md-12">
                                <div class="edit-profile mt-md-25 mt-0">
                                    <div class="card border-0">
                                        <div class="card-header border-0 pb-md-15 pb-10 pt-md-20 pt-10">
                                            <div class="edit-profile__title text-center">
                                                <div class="banned-icon mb-3">
                                                    <i class="fas fa-ban text-danger" style="font-size: 4rem;"></i>
                                                </div>
                                                <h4 class="text-danger mb-2">{{ $t("auth.account_banned") }}</h4>
                                                <p class="text-muted mb-0">{{ $t("auth.banned_message") }}</p>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            <div class="edit-profile__body text-center">
                                                <div class="banned-details mb-4">
                                                    <div class="alert alert-warning" role="alert">
                                                        <i class="fas fa-exclamation-triangle me-2"></i>
                                                        <strong>{{ $t("auth.banned_reason") }}:</strong>
                                                        <span v-if="banReason">{{ banReason }}</span>
                                                        <span v-else>{{ $t("auth.violation_of_terms") }}</span>
                                                    </div>
                                                    
                                                    <div class="banned-info mb-4">
                                                        <div class="row text-start">
                                                            <div class="col-md-6">
                                                                <p class="mb-2">
                                                                    <i class="fas fa-calendar-alt text-primary me-2"></i>
                                                                    <strong>{{ $t("auth.banned_date") }}:</strong>
                                                                    <span v-if="banDate">{{ formatDate(banDate) }}</span>
                                                                    <span v-else>{{ $t("auth.not_specified") }}</span>
                                                                </p>
                                                            </div>
                                                            <div class="col-md-6">
                                                                <p class="mb-2">
                                                                    <i class="fas fa-clock text-primary me-2"></i>
                                                                    <strong>{{ $t("auth.banned_duration") }}:</strong>
                                                                    <span v-if="banDuration">{{ banDuration }}</span>
                                                                    <span v-else>{{ $t("auth.permanent") }}</span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- Appeal Form -->
                                                <div v-if="showAppealForm" class="appeal-form mt-4">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <h6 class="card-title">{{ $t("auth.appeal_form_title") }}</h6>
                                                            <form @submit.prevent="submitAppeal">
                                                                <div class="form-group mb-3">
                                                                    <label class="form-label">{{ $t("auth.appeal_reason") }}</label>
                                                                    <textarea 
                                                                        class="form-control" 
                                                                        rows="4" 
                                                                        v-model="appealForm.reason"
                                                                        :placeholder="$t('auth.appeal_reason_placeholder')"
                                                                        required>
                                                                    </textarea>
                                                                </div>
                                                                <div class="form-group mb-3">
                                                                    <label class="form-label">{{ $t("auth.contact_email") }}</label>
                                                                    <input 
                                                                        type="email" 
                                                                        class="form-control" 
                                                                        v-model="appealForm.email"
                                                                        :placeholder="$t('auth.contact_email_placeholder')"
                                                                        required>
                                                                </div>
                                                                <div class="d-flex gap-2">
                                                                    <button 
                                                                        type="submit" 
                                                                        class="btn btn-primary"
                                                                        :disabled="isSubmittingAppeal">
                                                                        <span v-if="isSubmittingAppeal" class="spinner-border spinner-border-sm me-2"></span>
                                                                        {{ isSubmittingAppeal ? $t("auth.submitting") : $t("auth.submit_appeal") }}
                                                                    </button>
                                                                    <button 
                                                                        type="button" 
                                                                        class="btn btn-secondary"
                                                                        @click="showAppealForm = false">
                                                                        {{ $t("auth.cancel") }}
                                                                    </button>
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="back-to-login mt-4">
                                                    <hr>
                                                    <p class="text-muted mb-3">{{ $t("auth.try_different_account") }}</p>
                                                    <router-link to="/login" class="btn btn-outline-secondary">
                                                        <i class="fas fa-arrow-left me-2"></i>
                                                        {{ $t("auth.back_to_login") }}
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Banned',
    data() {
        return {
            banReason: null,
            banDate: null,
            banDuration: null,
            showAppealForm: false,
            isSubmittingAppeal: false,
            appealForm: {
                reason: '',
                email: ''
            }
        };
    },
    mounted() {
        // Get ban details from route params or store
        this.banReason = this.$route.query.reason || null;
        this.banDate = this.$route.query.date || null;
        this.banDuration = this.$route.query.duration || null;
        
        // Clear any existing auth data
        this.$store.dispatch('auth_logout');
    },
    methods: {
        formatDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleDateString('id-ID', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        },
        async submitAppeal() {
            this.isSubmittingAppeal = true;
            
            try {
                // Here you would typically send the appeal to your backend
                // For now, we'll just show a success message
                await new Promise(resolve => setTimeout(resolve, 2000)); // Simulate API call
                
                this.$toast.success(this.$t('auth.appeal_submitted_success'));
                this.showAppealForm = false;
                this.appealForm = { reason: '', email: '' };
                
            } catch (error) {
                this.$toast.error(this.$t('auth.appeal_submit_error'));
            }
            
            this.isSubmittingAppeal = false;
        }
    }
};
</script>

<style scoped>
.banned-icon {
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
    }
}

.banned-details .alert {
    border-left: 4px solid #ffc107;
}

.support-options .btn {
    min-width: 150px;
}

.appeal-form {
    animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.spinner-border-sm {
    width: 1rem;
    height: 1rem;
}

.card {
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    border: 1px solid rgba(0, 0, 0, 0.125);
}

.alert {
    border-radius: 0.375rem;
}

.btn {
    border-radius: 0.375rem;
}

.form-control {
    border-radius: 0.375rem;
}
</style>
